import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75094fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "sidebar-navigation",
  class: "components__side-bar print--hide"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-button-close" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#sidebar-navigation-close" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "frontend-icon fi-fa_times" })
  ])
], -1))
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = { class: "title__label" }
const _hoisted_5 = {
  key: 0,
  class: "entries"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "entry-without-target"
}
const _hoisted_8 = ["href"]

import { ref, computed } from "vue";
  import { useStore } from "vuex";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'side-bar',
  setup(__props) {

  const store = useStore();
  const expanded = ref<Array<any>>([]);

  const content = computed(() => store.state.gon.sidebar?.content);
  const currentPath = computed(() => window.location.pathname);

  const toggle = (index: number) => {
    expanded.value[index] = !expanded.value[index];
  };
  const isExpanded = (index: number) => {
    if(typeof(expanded.value[index]) === 'undefined' && initiallyExpanded(index)) {
      // sideeffect!
      expanded.value[index] = true;
    }
    return !!expanded.value[index];
  };
  const isActive = (entry: any) => {
    return entry.target && !entry.expand && ((entry.target ?? '').split('?')[0] === currentPath.value);
  };
  const initiallyExpanded = (index: number) => {
    if (content == undefined) return false;
    return content
      .value[index]
      .children
      .filter((child: any) => !!child)
      .map((child: any) => [child, ...(child.expand || [])])
      .flat()
      .some((entry:any) => isActive(entry));
  };

return (_ctx: any,_cache: any) => {
  return (content.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value, (section, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", {
              class: _normalizeClass(["title", {'extra-top-space': (index !== 0), 'title--accordion': section.accordion }]),
              title: section.title,
              onClick: ($event: any) => (toggle(index))
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(section.title), 1),
              (section.accordion)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(["frontend-icon", {'fi-expand_more': !isExpanded(index), 'fi-expand_less': isExpanded(index)}])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3),
            (section.children && (!section.accordion || isExpanded(index)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.children, (entry, indexEntry) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: indexEntry }, [
                      entry
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["entry", {active: isActive(entry)}])
                            }, [
                              (entry.target && !entry.expand)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: entry.target
                                  }, _toDisplayString(entry.label), 9, _hoisted_6))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(entry.label), 1))
                            ], 2),
                            (entry.expand)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(entry.expand, (subentry, indexSubentry) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: indexSubentry,
                                    class: _normalizeClass(["sub-entry", {active: isActive(subentry)}])
                                  }, [
                                    _createElementVNode("a", {
                                      href: subentry.target
                                    }, _toDisplayString(subentry.label), 9, _hoisted_8)
                                  ], 2))
                                }), 128))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})